/* Waco Diamonds — collection price control (native-filter integrated)
   On collection/search pages with combined-listing ring cards, injects three groups —
   Metal Karat / Carat Size / Diamond Quality — into the NATIVE Search & Discovery filter
   panel (desktop sidebar + mobile drawer), styled with the theme's own collapsible/checkbox
   markup so they read as native facets. Choosing values re-prices every ring card in place:
   a partial selection shows the theme's "From $X" for the matching range; a full selection
   shows that configuration's exact price. Metal colour does not affect price, so
   karat+carat+quality fully determines it. Each card carries a `data-waco-price-matrix` map
   written by the pricing app from live variant prices — every number shown is real and
   purchasable. Presentation-only: our inputs are NOT part of the facet query (no `filter.*`
   name) and their events are isolated so they never trigger a facet reload. Clicking a card
   carries the configuration to the PDP via a `#waco-config` hash. */
(function () {
  "use strict";
  if (window.__wacoCollectionPricer) return;
  window.__wacoCollectionPricer = true;

  var KARAT_ORDER = ["10K", "14K", "18K", "Platinum"];
  var QUALITY_ORDER = ["Good (F / VS1)", "Better (E / VVS2)", "Best (D / VVS1)"];

  var DIMS = [
    { key: "k", idx: 0, dim: "karat", label: "Metal Karat", order: KARAT_ORDER, fmt: null },
    { key: "c", idx: 1, dim: "carat", label: "Carat Size", order: null, fmt: function (v) { return v + " ct"; } },
    { key: "q", idx: 2, dim: "quality", label: "Diamond Quality", order: QUALITY_ORDER, fmt: null },
  ];

  // theme icon paths (copied from the native facet markup so our groups match exactly)
  var CHECK = "m12.9 5.77-6 6a.56.56 0 0 1-.8 0L3.48 9.15a.56.56 0 0 1 .8-.8l2.22 2.23 5.6-5.6a.56.56 0 0 1 .8.8Z";
  var PLUS = "M8 2.75C8 2.47386 7.77614 2.25 7.5 2.25C7.22386 2.25 7 2.47386 7 2.75V7H2.75C2.47386 7 2.25 7.22386 2.25 7.5C2.25 7.77614 2.47386 8 2.75 8H7V12.25C7 12.5261 7.22386 12.75 7.5 12.75C7.77614 12.75 8 12.5261 8 12.25V8H12.25C12.5261 8 12.75 7.77614 12.75 7.5C12.75 7.22386 12.5261 7 12.25 7H8V2.75Z";
  var MINUS = "M2.25 7.5C2.25 7.22386 2.47386 7 2.75 7H12.25C12.5261 7 12.75 7.22386 12.75 7.5C12.75 7.77614 12.5261 8 12.25 8H2.75C2.47386 8 2.25 7.77614 2.25 7.5Z";

  // shared selection state (null = "Any")
  var sel = { k: null, c: null, q: null };          // karat/carat/quality → reprice
  var filterSel = { shape: null, shank: null };     // diamond shape / shank style → hide cards
  var priceSel = { from: null, to: null };          // price range → hide cards
  var OPTS = null; // { karats, carats, quals }
  var FILTER_OPTS = { shape: [], shank: [] };
  var PRICE_BOUNDS = null; // { min, max } across all cards' matrices

  // Native Search & Discovery can't index combined-listing parents, so Diamond Shape / Shank Style /
  // Price are injected here as custom groups that FILTER the grid client-side (hide non-matching
  // cards), alongside the karat/carat/quality groups that reprice. Each card carries data-waco-shape
  // and data-waco-shank (from the parent metafields) and data-waco-price-matrix.
  var FILTERS = [
    { key: "shape", dim: "shape", label: "Diamond Shape", attr: "data-waco-shape" },
    { key: "shank", dim: "shank", label: "Shank Style", attr: "data-waco-shank" },
  ];

  // money helpers (mirror the format of the card's own rendered price)
  function inferFormat(sample) {
    var firstDigit = sample.search(/\d/);
    if (firstDigit < 0) return { prefix: "$", suffix: "", decimals: 0, lead: "" };
    var lastDigit = -1;
    for (var i = sample.length - 1; i >= 0; i--) {
      if (/\d/.test(sample[i])) { lastDigit = i; break; }
    }
    var leadAll = sample.slice(0, firstDigit); // e.g. "From $"
    var suffix = sample.slice(lastDigit + 1);
    var core = sample.slice(firstDigit, lastDigit + 1);
    var pm = leadAll.match(/[^0-9A-Za-z\s]+\s*$/); // trailing currency symbol run
    var prefix = pm ? pm[0].trim() : "";
    var lead = pm ? leadAll.slice(0, leadAll.length - pm[0].length) : leadAll; // e.g. "From "
    var decimals = /[.,]\d{2}$/.test(core) ? 2 : 0;
    return { prefix: prefix, suffix: suffix, decimals: decimals, lead: lead };
  }
  function fmt(amount, f) {
    var fixed = Number(amount).toFixed(f.decimals);
    var parts = fixed.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return f.prefix + parts[0] + (parts[1] ? "." + parts[1] : "") + f.suffix;
  }

  function priceNode(card) {
    return card.querySelector(
      ".card-product-content__price .price__regular span:not(.visually-hidden)"
    );
  }

  // per-card init (idempotent)
  function initCard(card) {
    if (card.__wacoInit) return card.__wacoMatrix ? card : null;
    card.__wacoInit = true;
    var raw = card.getAttribute("data-waco-price-matrix");
    var node = priceNode(card);
    if (!raw || !node) return null;
    try { card.__wacoMatrix = JSON.parse(raw); } catch (e) { return null; }
    var text = node.textContent.trim();
    card.__wacoDefaultText = text;
    card.__wacoFmt = inferFormat(text);
    return card;
  }
  function collectCards() {
    var found = [];
    var els = document.querySelectorAll(".card-product[data-waco-price-matrix]");
    for (var i = 0; i < els.length; i++) {
      var c = initCard(els[i]);
      if (c) found.push(c);
    }
    return found;
  }

  function optionUnion(cards) {
    var K = {}, C = {}, Q = {};
    cards.forEach(function (card) {
      Object.keys(card.__wacoMatrix).forEach(function (key) {
        var p = key.split("|");
        K[p[0]] = 1; C[p[1]] = 1; Q[p[2]] = 1;
      });
    });
    return {
      karats: Object.keys(K).sort(function (a, b) { return KARAT_ORDER.indexOf(a) - KARAT_ORDER.indexOf(b); }),
      carats: Object.keys(C).sort(function (a, b) { return parseFloat(a) - parseFloat(b); }),
      quals: Object.keys(Q).sort(function (a, b) { return QUALITY_ORDER.indexOf(a) - QUALITY_ORDER.indexOf(b); }),
    };
  }

  // price for the current selection: min matching amount + whether the match still ranges
  function priceFor(matrix) {
    var min = Infinity, max = -Infinity, n = 0;
    for (var key in matrix) {
      if (!Object.prototype.hasOwnProperty.call(matrix, key)) continue;
      var p = key.split("|");
      if (sel.k && p[0] !== sel.k) continue;
      if (sel.c && p[1] !== sel.c) continue;
      if (sel.q && p[2] !== sel.q) continue;
      var v = matrix[key];
      if (v < min) min = v;
      if (v > max) max = v;
      n++;
    }
    if (!n) return null;
    return { amount: min, ranges: max !== min };
  }

  // min/max price for a card under the current karat/carat/quality selection
  function cardRange(matrix) {
    var min = Infinity, max = -Infinity, n = 0;
    for (var key in matrix) {
      if (!Object.prototype.hasOwnProperty.call(matrix, key)) continue;
      var p = key.split("|");
      if (sel.k && p[0] !== sel.k) continue;
      if (sel.c && p[1] !== sel.c) continue;
      if (sel.q && p[2] !== sel.q) continue;
      var v = matrix[key];
      if (v < min) min = v;
      if (v > max) max = v;
      n++;
    }
    return n ? { min: min, max: max } : null;
  }
  function computePriceBounds(cards) {
    var min = Infinity, max = -Infinity;
    cards.forEach(function (card) {
      var m = card.__wacoMatrix; if (!m) return;
      for (var key in m) {
        if (!Object.prototype.hasOwnProperty.call(m, key)) continue;
        var v = m[key]; if (v < min) min = v; if (v > max) max = v;
      }
    });
    return min === Infinity ? null : { min: Math.floor(min), max: Math.ceil(max) };
  }
  function priceActive() {
    if (!PRICE_BOUNDS) return false;
    return (priceSel.from != null && priceSel.from > PRICE_BOUNDS.min) ||
           (priceSel.to != null && priceSel.to < PRICE_BOUNDS.max);
  }
  function cardMatches(card) {
    if (filterSel.shape && card.getAttribute("data-waco-shape") !== filterSel.shape) return false;
    if (filterSel.shank && card.getAttribute("data-waco-shank") !== filterSel.shank) return false;
    if (priceActive()) {
      var r = cardRange(card.__wacoMatrix);
      if (r) {
        var from = priceSel.from != null ? priceSel.from : -Infinity;
        var to = priceSel.to != null ? priceSel.to : Infinity;
        if (r.min > to || r.max < from) return false;
      }
    }
    return true;
  }
  function gridItem(card) { return card.closest("li") || card.parentElement; }

  var allAny = function () { return !sel.k && !sel.c && !sel.q; };
  function configKey() {
    // only a fully-specified selection maps to a single PDP variant
    if (sel.k && sel.c && sel.q) return sel.k + "|" + sel.c + "|" + sel.q;
    return null;
  }

  // re-price every card for the current selection
  function reprice() {
    collectCards().forEach(function (card) {
      var item = gridItem(card);
      if (item) item.style.display = cardMatches(card) ? "" : "none";
      var node = priceNode(card);
      if (!node || !card.__wacoMatrix) return;
      var priceEl = card.querySelector(".card-product-content__price");
      if (allAny()) {
        node.textContent = card.__wacoDefaultText;
        if (priceEl) priceEl.classList.remove("waco-priced");
        return;
      }
      var r = priceFor(card.__wacoMatrix);
      if (!r) { // this ring doesn't offer the combo — keep its native price
        node.textContent = card.__wacoDefaultText;
        if (priceEl) priceEl.classList.remove("waco-priced");
        return;
      }
      node.textContent = r.ranges ? card.__wacoFmt.lead + fmt(r.amount, card.__wacoFmt) : fmt(r.amount, card.__wacoFmt);
      if (priceEl) priceEl.classList.add("waco-priced");
    });
  }

  // native-styled group markup
  function svg(cls, path) {
    return (
      '<svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" ' +
      'class="' + cls + '" fill="currentColor"><path d="' + path + '" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>'
    );
  }
  function radioRow(spec, scope, value, labelText, checked) {
    var id = "waco-" + scope + "-" + spec.dim + "-" + value.replace(/[^a-z0-9]+/gi, "-");
    return (
      '<div class="checkbox">' +
      '<input type="radio" data-waco-radio form="waco-detached" data-waco-dim="' + spec.key + '" name="waco-' + spec.dim + "-" + scope + '"' +
      ' value="' + (value === "__any__" ? "" : value.replace(/"/g, "&quot;")) + '" id="' + id + '" class="checkbox__input"' +
      (checked ? " checked" : "") + ">" +
      '<label for="' + id + '" class="checkbox__label">' +
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="checkbox__icon" viewBox="0 0 16 16"><path fill="" d="' + CHECK + '"/></svg>' +
      '<span class="checkbox__label-text">' + labelText + "</span></label></div>"
    );
  }
  function groupHTML(spec, scope, values) {
    var current = stateFor(spec.key)[spec.key];
    var rows = radioRow(spec, scope, "__any__", "Any", !current);
    values.forEach(function (v) {
      rows += radioRow(spec, scope, v, spec.fmt ? spec.fmt(v) : v, current === v);
    });
    return (
      '<collapsible-content data-waco-group="' + spec.dim + '">' +
      '<details class="collapsible__item" id="Details-waco-' + scope + "-" + spec.dim + '">' +
      '<summary class="collapsible__toggle h6">' +
      '<span class="collapsible__heading">' + spec.label + "</span>" +
      svg("collapsible__icon collapsible__icon--plus icon--s icon icon--plus", PLUS) +
      svg("collapsible__icon collapsible__icon--minus icon--s icon icon--minus", MINUS) +
      "</summary>" +
      '<div class="collapsible__content" data-content>' +
      '<fieldset class="facets-filters-form__fieldset">' +
      '<legend class="visually-hidden">' + spec.label + " (updates price)</legend>" +
      '<div class="facets-filters-form__list">' + rows + "</div>" +
      "</fieldset></div></details></collapsible-content>"
    );
  }

  function stateFor(key) { return key === "shape" || key === "shank" ? filterSel : sel; }

  function priceGroupHTML(scope) {
    if (!PRICE_BOUNDS) return "";
    var lo = priceSel.from != null ? priceSel.from : PRICE_BOUNDS.min;
    var hi = priceSel.to != null ? priceSel.to : PRICE_BOUNDS.max;
    return (
      '<collapsible-content data-waco-group="price">' +
      '<details class="collapsible__item" id="Details-waco-' + scope + '-price">' +
      '<summary class="collapsible__toggle h6"><span class="collapsible__heading">Price</span>' +
      svg("collapsible__icon collapsible__icon--plus icon--s icon icon--plus", PLUS) +
      svg("collapsible__icon collapsible__icon--minus icon--s icon icon--minus", MINUS) +
      "</summary>" +
      '<div class="collapsible__content" data-content>' +
      '<fieldset class="facets-filters-form__fieldset waco-price">' +
      '<div class="waco-price__row">' +
      '<label class="waco-price__field"><span class="waco-price__cap">From</span>' +
      '<input type="number" data-waco-price="from" form="waco-detached" inputmode="numeric" min="' + PRICE_BOUNDS.min + '" max="' + PRICE_BOUNDS.max + '" step="50" value="' + lo + '"></label>' +
      '<label class="waco-price__field"><span class="waco-price__cap">To</span>' +
      '<input type="number" data-waco-price="to" form="waco-detached" inputmode="numeric" min="' + PRICE_BOUNDS.min + '" max="' + PRICE_BOUNDS.max + '" step="50" value="' + hi + '"></label>' +
      "</div></fieldset></div></details></collapsible-content>"
    );
  }

  function injectInto(container, scope) {
    if (!container) return;
    // Self-healing: native renderFilters() strips any `[data-filter-form] details` whose id isn't
    // in the server HTML on every facet re-render — removing our <details> but leaving the empty
    // <collapsible-content data-waco-group> wrapper behind. So test for our actual radios, not the
    // wrapper: if the radios are gone, drop any stale wrappers and re-inject a fresh set.
    if (container.querySelector("input[data-waco-radio]")) return; // intact — nothing to do
    var stale = container.querySelectorAll("[data-waco-group]");
    for (var s = 0; s < stale.length; s++) stale[s].parentNode.removeChild(stale[s]);
    var html = "";
    DIMS.forEach(function (spec) {
      var values = spec.key === "k" ? OPTS.karats : spec.key === "c" ? OPTS.carats : OPTS.quals;
      html += groupHTML(spec, scope, values);
    });
    FILTERS.forEach(function (spec) {
      var values = FILTER_OPTS[spec.key] || [];
      if (values.length > 1) html += groupHTML(spec, scope, values); // only worth filtering if >1 value
    });
    html += priceGroupHTML(scope);
    container.insertAdjacentHTML("beforeend", html);
  }

  function injectAll() {
    // Inject into the native filter panel wherever it exists — the `__content` container is
    // present (with a "Filters" header) even when the store has NO active Search & Discovery
    // filters, so we must NOT gate on `.facets-filters-form__list` (that only exists once
    // there are filter groups). Gating on it made the control fall back to the bar on
    // collections with no S&D filters enabled.
    var containers = document.querySelectorAll(".facets-filters-form__content");
    var n = 0;
    containers.forEach(function (c) { injectInto(c, n++); });
    return containers.length;
  }

  // keep every panel's radios in sync with the shared selection
  function syncRadios() {
    DIMS.concat(FILTERS).forEach(function (spec) {
      var want = stateFor(spec.key)[spec.key] || "";
      document.querySelectorAll('input[data-waco-radio][data-waco-dim="' + spec.key + '"]').forEach(function (r) {
        r.checked = r.value === want;
      });
    });
  }

  // PDP deep-link: stamp #waco-config onto a clicked card link at click time
  function stampHref(e) {
    var link = e.target.closest && e.target.closest(".card-product[data-waco-price-matrix] .expand-link__link");
    if (!link) return;
    var key = configKey();
    var href = (link.getAttribute("href") || "").replace(/#waco-config=[^#]*/, "").replace(/#$/, "");
    link.setAttribute("href", key ? href + "#waco-config=" + encodeURIComponent(key) : href);
  }

  function hideNativePrice() {
    document.querySelectorAll("price-range").forEach(function (pr) {
      var det = pr.closest("details");
      (det || pr).style.display = "none";
    });
  }
  function injectStyle() {
    if (document.getElementById("waco-pricer-style")) return;
    var st = document.createElement("style");
    st.id = "waco-pricer-style";
    st.textContent =
      ".waco-price__row{display:flex;gap:.75rem;align-items:flex-end}" +
      ".waco-price__field{flex:1;display:flex;flex-direction:column;gap:.25rem}" +
      ".waco-price__cap{font-size:.75rem;opacity:.7}" +
      ".waco-price__field input{width:100%;padding:.45rem .55rem;border:1px solid rgba(var(--color-foreground),.35);border-radius:.25rem;background:transparent;color:inherit;font:inherit}";
    document.head.appendChild(st);
  }

  // Auto-load the rest of a paginated collection when a filter is active, so shape/shank/price
  // filter across ALL products, not just the first loaded page. Native server-side filtering isn't
  // available (combined listings aren't indexed), so we fetch the remaining pages client-side —
  // only when a filter is actually used, keeping the initial page fast.
  var allLoaded = false, loadingAll = false;
  function filterActive() { return !!(filterSel.shape || filterSel.shank || priceActive()); }
  function cardKey(li) { var a = li.querySelector(".expand-link__link[href]"); return a ? a.getAttribute("href").split("?")[0] : null; }
  function appendPage(url, seen) {
    return fetch(url, { credentials: "same-origin" }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var src = doc.querySelector("#ProductGrid"), dst = document.querySelector("#ProductGrid");
      if (!src || !dst) return 0;
      var added = 0, lis = src.children;
      for (var i = 0; i < lis.length; i++) {
        // Only append real product cards. Pages past the last one return an empty-state grid
        // ("No products found." + a "Continue shopping" button) — appending those would pile
        // junk into the grid AND keep the loop paging forever, so skip any non-card <li>.
        if (!lis[i].querySelector(".card-product")) continue;
        var key = cardKey(lis[i]);
        if (key && seen[key]) continue; // de-dupe against already-present cards
        if (key) seen[key] = 1;
        dst.appendChild(document.importNode(lis[i], true));
        added++;
      }
      return added;
    }).catch(function () { return 0; });
  }
  // Page by number (?page=N) rather than the load-more <a> — the native infinite-scroll script
  // rewrites/removes that anchor at runtime. Stop when a page yields no new cards.
  function loadAllPages() {
    loadingAll = true;
    var seen = {};
    document.querySelectorAll("#ProductGrid > li").forEach(function (li) { var k = cardKey(li); if (k) seen[k] = 1; });
    var page = 2;
    function step() {
      var u; try { u = new URL(window.location.href); } catch (e) { return Promise.resolve(); }
      u.searchParams.delete("page");
      u.searchParams.set("page", String(page));
      return appendPage(u.href, seen).then(function (added) {
        page++;
        if (added > 0 && page <= 50) return step(); // continue while pages yield new cards (safety cap)
      });
    }
    return step().then(function () {
      allLoaded = true; loadingAll = false;
      // Hide the load-more control now that every page is in the DOM. NOTE: #ProductGrid lives
      // INSIDE <collection-infinite-scroll>, so we must hide #ProductLoadMore (the "You've viewed
      // X of Y" + button footer), NOT the scroll wrapper — hiding the wrapper would hide the grid.
      var lm = document.getElementById("ProductLoadMore"); if (lm) lm.style.display = "none";
    }).catch(function () { loadingAll = false; });
  }
  function maybeLoadAll() {
    if (!filterActive() || allLoaded || loadingAll) return;
    loadAllPages().then(function () { syncRadios(); reprice(); });
  }

  function build() {
    // Stand down where the PER-CARD configurator owns pricing (engagement collection): both write
    // the same card price node, so running both would fight. The marker is server-rendered.
    if (document.querySelector("[data-waco-per-card-pricer]")) return;
    var cards = collectCards();
    if (!cards.length) return;
    // Only run where the native Search & Discovery filter panel exists. card-product.liquid
    // includes this script on any surface that renders ring cards (homepage featured sections,
    // search, etc.); those have no <facets-form>, so without this gate we'd render an orphan
    // control with nowhere to live. No native panel → no price control (by design).
    if (!document.querySelector("facets-form")) return;
    OPTS = optionUnion(cards);
    if (!OPTS.karats.length || !OPTS.carats.length || !OPTS.quals.length) return;

    // Shape/shank option unions (from card attributes) + price bounds, for the injected filters.
    var shapes = {}, shanks = {};
    cards.forEach(function (card) {
      var sh = card.getAttribute("data-waco-shape"); if (sh) shapes[sh] = 1;
      var sk = card.getAttribute("data-waco-shank"); if (sk) shanks[sk] = 1;
    });
    FILTER_OPTS = { shape: Object.keys(shapes).sort(), shank: Object.keys(shanks).sort() };
    PRICE_BOUNDS = computePriceBounds(cards);
    injectStyle();
    hideNativePrice();

    injectAll();

    // The native facets <form> listens on `input` (see facets.js) and debounces a full AJAX
    // re-render that would wipe our injected groups and serialize our inputs into the URL. Our
    // radios fire both `input` and `change`; we stop BOTH in the capture phase so neither reaches
    // the native form. `change` also drives our own selection logic. Belt-and-suspenders: the
    // radios carry form="waco-detached" so they're excluded from the facets FormData regardless.
    function readPrice(t) {
      var v = parseFloat((t.value || "").replace(/[^0-9.]/g, ""));
      priceSel[t.getAttribute("data-waco-price")] = isNaN(v) ? null : v;
    }
    document.addEventListener("input", function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches("input[data-waco-radio]")) { e.stopPropagation(); }
      else if (t.matches("input[data-waco-price]")) { e.stopPropagation(); readPrice(t); reprice(); maybeLoadAll(); }
    }, true);
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches("input[data-waco-radio]")) {
        e.stopPropagation();
        var dim = t.getAttribute("data-waco-dim");
        stateFor(dim)[dim] = t.value || null;
        syncRadios();
        reprice();
        maybeLoadAll();
      } else if (t.matches("input[data-waco-price]")) {
        e.stopPropagation();
        readPrice(t);
        reprice();
        maybeLoadAll();
      }
    }, true);

    document.addEventListener("mousedown", stampHref, true);
    document.addEventListener("click", stampHref, true);

    // Re-inject + re-price after the facet panel / product grid re-render via AJAX.
    // The observer is DISCONNECTED while we mutate (injecting groups + rewriting price text),
    // then reconnected — otherwise our own price-text writes would re-trigger it in a loop.
    if (window.MutationObserver) {
      var scheduled = false;
      var obs = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          obs.disconnect();
          injectAll();
          hideNativePrice();
          syncRadios();
          reprice();
          obs.observe(document.body, { childList: true, subtree: true });
        });
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }

    reprice();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", build);
  } else {
    build();
  }
})();
